// Token validation is handled server-side via /api/validate-token
// The token list lives in a Vercel environment variable (VALID_TOKENS)
// and is never exposed in the frontend JS bundle.

export interface ClientToken {
  token: string;
  clientName: string;
}

export async function validateToken(token: string): Promise<ClientToken | null> {
  if (!token) return null;

  try {
    const res = await fetch('/api/validate-token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });

    if (!res.ok) return null;

    const data = await res.json();
    if (!data.valid) return null;

    return { token, clientName: data.clientName || '' };
  } catch {
    return null;
  }
}
